<template>
  <div class="allcontant">
    <div class="listBox">
        <div class="title">大赛动态</div>
        <div class="mall" @click="gotoMore">
          更多
          <li class="el-icon-arrow-right"></li>
        </div>
        <div v-for="(item,index) in matchList" :key="index" class="item" @click="toinfo(item.id)">
          <div class="imgbox">
            <img :src="item.img">
          </div>
          <div class="right">
            <div class="itemTitle">{{item.title}}</div>
            <div class="content">{{item.content}}</div>
            <div class="time">发布时间：{{item.issueTime}}</div>
          </div>
        </div>
    </div>
    <div class="listBox" style="margin-top: 80px;">
      <div class="title">大赛动态</div>
      <div class="mall" @click="gotoSchoolMore">
        更多
        <li class="el-icon-arrow-right"></li>
      </div>
      <div v-for="(item,index) in schoolList" :key="index" class="item" @click="toinfo(item.id)">
        <div class="imgbox">
          <img :src="item.img">
        </div>
        <div class="right">
          <div class="itemTitle">{{item.title}}</div>
          <div class="content">{{item.content}}</div>
          <div class="time">发布时间：{{item.issueTime}}</div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import { Session } from '@/utils/storage';
import {getData} from "@/api/news"
export default {
 data(){
   return{
     params:{
       page:1,
       limit:5,
       matchId:'',
       orderRule: "create_time"
     },
     matchList:{},
     schoolList:{},
     list:[
        {img:'https://img1.baidu.com/it/u=2636629975,1133333551&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',title:'教育部关于举办首届全国大学生职业规划大赛的通知',content:'为贯彻落实党中央、国务院关于高校毕业生就业工作的决策为贯彻落实党中央、国务院关于高校毕业生就业工作的决策 部署，落实《国务院关于印发 "十四五"就业促进规划的通知》 （国发〔2021〕14 号）',time:'2024-07-12'},
        {img:'https://img1.baidu.com/it/u=2636629975,1133333551&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',title:'教育部关于举办首届全国大学生职业规划大赛的通知',content:'为贯彻落实党中央、国务院关于高校毕业生就业工作的决策 部署，落实《国务院关于印发 "十四五"就业促进规划的通知》 （国发〔2021〕14 号）',time:'2024-07-12'},
        {img:'https://img1.baidu.com/it/u=2636629975,1133333551&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',title:'教育部关于举办首届全国大学生职业规划大赛的通知',content:'为贯彻落实党中央、国务院关于高校毕业生就业工作的决策 部署，落实《国务院关于印发 "十四五"就业促进规划的通知》 （国发〔2021〕14 号）',time:'2024-07-12'},
      ]
   }
 },
 mounted(){
   this.getList()
 },
 methods:{
   getList(){
     this.params.matchId = Session.get("matchID")
     getData(this.params).then(res=>{
       this.matchList = res.data.data.matchList.list
       this.matchList.forEach(item=>{
         item.content = item.content.replace(/<[^>]+>/g, "");
         item.content = item.content.replace(/[ ]|[&nbsp;]/g, '')
       })
       this.schoolList = res.data.data.schoolList.list
        this.schoolList.forEach(item=>{
        item.content = item.content.replace(/<[^>]+>/g, "");
         item.content = item.content.replace(/[ ]|[&nbsp;]/g, '')
       })
     })
   },
   gotoMore(e){
     this.$router.push({path:"/NewsMore",query:{type:e}})
   },
   gotoSchoolMore(){
     this.$router.push({path:"/SchoolMore"})
   },
   toinfo(e){
    this.$router.push({path:'/newsInfo',query:{id:e}})
  }
 }
}
</script>

<style scoped>
  .allcontant {
      height: auto;
      min-height: calc(100vh - 140px);
      margin-top: 100px;
      /* background-color: #f1f1f1; */
      margin-bottom: 30px;
      margin-top: 120px !important;
  }
  .listBox{
    width: 1200px;
    margin:0 auto;
    text-align: center;
  }
  .title{
    font-weight: 600;
    font-size: 40px;
    color: #333333;
  }
  .mall{
    font-weight: 400;
    font-size: 18px;
    color: #4F90FD;
    margin: 22px 0 40px;
    cursor: pointer;
  }
  .item{
    height: 220px;
    background: #FFFFFF;
    border-radius: 16px 16px 16px 16px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .item img{
    width: 260px;
    height: 220px;
    border-radius: 16px 0px 0px 16px;
  }
  .imgbox{
    width: 260px;
    height: 220px;
    border-radius: 16px 0px 0px 16px;
  }
  .right{
    padding:10px 30px;
    text-align: left;
    height: 100%;
    width: 940px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .itemTitle{
    font-weight: 500;
    font-size: 30px;
    color: #333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
  .content{
    font-weight: 400;
    font-size: 24px;
    color: #666666;
    margin: 10px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
  .time{
    font-weight: 400;
    font-size: 20px;
    color: #999999;
  }
  @media screen and (max-width:1400px) {
    .listBox{
      width: 840px;
      margin:0 auto;
      text-align: center;
    }
    .title{
      font-weight: 600;
      font-size: 30px;
      color: #333333;
    }
    .mall{
      font-weight: 400;
      font-size: 16px;
      color: #4F90FD;
      margin: 22px 0 40px;
      cursor: pointer;
    }
    .item{
      height: 154px;
      background: #FFFFFF;
      border-radius: 16px 16px 16px 16px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .item img{
      width: 182px;
      height: 154px;
      border-radius: 16px 0px 0px 16px;
    }
    .imgbox{
      width: 182px;
      height: 154px;
      border-radius: 16px 0px 0px 16px;
    }
    .right{
      padding:10px 30px;
      text-align: left;
      height: 100%;
      width: 658px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .itemTitle{
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
    }
    .content{
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      margin: 10px 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
    }
    .time{
      font-weight: 400;
      font-size: 16px;
      color: #999999;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/News.vue